<div class="flex-direction-column page" [style]="isHml ? 'height: calc(-77px + 100vh)' : 'height: calc(-61px + 100vh)'">
  <div class="flex-direction-row justify-between align-center wrap gap-10 toolbar-usuarios" style="padding: 10px 0 10px 0;">
    <div class="flex-direction-row align-center gap-10 wrap" style="width: 100%;">
      <app-button-padrao iconSrc="icones/filtros" iconSrcExtensao=".svg"
        width="30px" height="30px" backgroundColor="transparent"
        widthIcon="22px" heightIcon="22px"
        matTooltip="Filtrar"
        (buttonClick)="abrirModalFiltro()">
      </app-button-padrao>
      <app-button-padrao iconSrc="icones/limpar" iconSrcExtensao=".svg"
        width="30px" height="30px" backgroundColor="transparent"
        widthIcon="22px" heightIcon="22px"
        matTooltip="Limpar filtros"
        (buttonClick)="limparFiltros()">
      </app-button-padrao>
      <app-form-field style="margin-right: 1%" placeholder="Pesquisar" iconPrefix="search" iconColor="var(--primary)" backgroundColor="transparent" classe="pesquisar"
        widthFormField="325px" heightFormField="35px" borderColor="var(--primary)" (changeValue)="filtrarUsuarios($event)"></app-form-field>
    </div>
  </div>

  @if (usuarios.length > 0 && !carregandoUsuarios) {
    <mat-table [dataSource]="dataSource" style="width: 98%; overflow: auto;">
      <ng-container matColumnDef="acao">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <div class="flex-direction-row gap-5">
            <app-button-padrao iconSrc="icones/edit" iconSrcExtensao=".svg" width="30px" height="30px" backgroundColor="transparent"
              widthIcon="22px" heightIcon="22px" (buttonClick)="abrirModal(false, elemento)"></app-button-padrao>
            <app-button-padrao iconSrc="icones/visualizar" iconSrcExtensao=".svg" width="30px" height="30px" backgroundColor="transparent"
              widthIcon="20px" heightIcon="20px" (buttonClick)="abrirModal(true, elemento)"></app-button-padrao>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="foto">
        <mat-header-cell *matHeaderCellDef> Foto </mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          @if (elemento.extensaoImg && elemento.uuid) {
            <img class="circulo" [src]="gerarUrl(elemento.uuid, elemento.extensaoImg, 'usuario-img')" class="modal-lateral-imagem" style="width: 25px; height: 25px; cursor: unset;" alt="Foto do usuário" />
          } @else {
            <img src="./assets/icones/no-img-default.png" style="width: 25px; height: 25px" alt="Foto do usuário" />
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nome">
        <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <span [matTooltip]="elemento.nome" class="ellipse">
            {{ elemento.nome }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="telefone">
        <mat-header-cell *matHeaderCellDef> Telefone </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento.telefone | celularMask }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef> E-mail </mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <span [matTooltip]="elemento.email" class="ellipse">
            {{ elemento.email }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="perfil">
        <mat-header-cell *matHeaderCellDef> Perfil </mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <span [matTooltip]="elemento.perfil?.nome" class="ellipse">
            {{ elemento.perfil?.nome }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="setor">
        <mat-header-cell *matHeaderCellDef> Setor </mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <span [matTooltip]="elemento.setorDTO?.nome ?? '-'" class="ellipse">
            {{ elemento.setorDTO?.nome ?? '-' }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="usuarioCriacao">
        <mat-header-cell *matHeaderCellDef> Usuário Criação </mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <span [matTooltip]="elemento.usuarioCriacao?.nome ?? ''" class="ellipse">
            {{ elemento.usuarioCriacao?.nome ?? '--' }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dataCriacao">
        <mat-header-cell *matHeaderCellDef> Data Criação </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento.dataCriacao | date: 'dd/MM/yyyy HH:mm' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="usuAlteracao">
        <mat-header-cell *matHeaderCellDef> Usu. Alteração </mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <span [matTooltip]="elemento.usuarioAlteracao?.nome ?? ''" class="ellipse">
            {{ elemento.usuarioAlteracao?.nome ?? '--' }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dataAlteracao">
        <mat-header-cell *matHeaderCellDef> Data Alteração </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ (elemento.dataAlteracao ? elemento.dataAlteracao : elemento.dataCriacao) | date: 'dd/MM/yyyy HH:mm' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="ativo">
        <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento.ativo ? 'Ativo' : 'Inativo' }} </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
    <app-paginator
      [length]="length"
      [pageSize]="limit"
      [pageIndex]="page"
      [pageSizeOptions]="pageSizeOptions"
      [width]="'calc(100% - 16px) !important'"
      (pageChange)="handlePageEvent($event)">
    </app-paginator>
  }
  @else if (usuarios.length <= 0 && !carregandoUsuarios){
    <div class="flex center-center height-100">
      <img style="height: 394px; width: 582px;" src="./assets/imagem-mulher-nao-eh-bug.png" alt="Nenhum usuário encontrado">
    </div>
  }@else if(carregandoUsuarios){
    <app-tabela-skeleton [qntdLinhas]="5"></app-tabela-skeleton>
  }

  <img src="./assets/botao-add.svg" class="botao-add cursor-pointer" (click)="abrirModal(false)"
       (keydown.enter)="abrirModal(false)" tabindex="0" role="button" alt="Adicionar usuário" />
</div>
